import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Owned } from 'app/model/base/named';
import { IModel } from 'app/model/base/annotation';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/format-write-settings';
import { BaseAsyncAdapter, ITridentResource } from 'shell-models-lib';

export const formatWriteSettingsAdapts = {
    type: '*',
    maxRowsPerFile: '*',
    fileNamePrefix: '*'
};

export abstract class FormatWriteSettingsAdapter<T, U> extends BaseAsyncAdapter<T, U> {
    public static toFormatWriteSettingsResource(model: FormatWriteSettings, resource: Model.FormatWriteSettings): void {
        if (model != null && resource != null) {
            resource.maxRowsPerFile = ValueAdapter.toResource(model, FormatWriteSettings.MAXROWS_PER_FILE);
            if (resource.maxRowsPerFile != null) {
                resource.fileNamePrefix = ValueAdapter.toResource(model, FormatWriteSettings.FILENAME_PREFIX);
            }
        }
    }

    public static toFormatWriteSettingsModel(resource: Model.FormatWriteSettings, model: FormatWriteSettings): void {
        if (model != null && resource != null) {
            ValueAdapter.toModel(model, FormatWriteSettings.MAXROWS_PER_FILE, resource.maxRowsPerFile);
            ValueAdapter.toModel(model, FormatWriteSettings.FILENAME_PREFIX, resource.fileNamePrefix);
        }
    }

    public static getCommonWriteSettingsProperties(settingType: string): Model.FormatWriteSettings {
        return {
            type: settingType
        };
    }

    public static createWriteSettingsWithCommonProperties(model: IModel, copySink: CopySink): FormatWriteSettings {
        return Owned.create<FormatWriteSettings>(model, copySink);
    }

    protected async _toAzureResource(tridentResource: ITridentResource): Promise<U> {
        throw `Artifact type '${tridentResource.artifactType}' does not implement _toAzureResource method.`;
    }
}
